/**
 * @function createImage
 * @description Creates the HTML Image Element
 * @param {Document} document The DOM object
 * @param {Object} ENV_CONFIG Environment config that is passed in globally.
 * @param {String} ENV_CONFIG.imageUrl Image Url that is defined in the environment config.
 * @param {Object} CONSTANTS Alberta Constants
 * @param {Number} CONSTANTS.IMAGE_DEFAULT_SIZE Default image size for the SRC Mark
 * @param {String} CONSTANTS.IMAGE_ALT_TEXT Image alt text.
 * @param {String|Number} imageSize Image size specified from the Merchant
 * selected element. If nothing is passed in, then it will default to
 * CONSTANT.IMAGE_DEFAULT_SIZE.
 * @returns {HTML} Image tag with the SRC Mark.
 */
export const createImage = (document, CONSTANTS, imageSize) => {
  const imageElement = document.createElement('img')
  imageSize = (imageSize !== undefined) ? imageSize : CONSTANTS.IMAGE_DEFAULT_SIZE
  imageElement.setAttribute('src', `${CONSTANTS.IMAGE_DEFAULT_URL}?imageSize=${imageSize}`)
  imageElement.setAttribute('alt', CONSTANTS.IMAGE_ALT_TEXT)
  imageElement.setAttribute('style', 'border-radius: 10px;')
  return imageElement
}
